<template>
  <div id="tab-ams" class="ams-info">
    <!--AMS按钮：数据抄录/同步HBL信息/代码检索...-->
    <div class="section operations">
      <div class="triggers">
        <div>
          <!--
          <el-button :disabled="readonly" type="primary" @click="aiRecognitionHandler(true, pm.aiRecognitionPostHandlerByCargoDoc)">{{ getItemTitle('Ai Recognition') }}</el-button>
-->
          <el-button :disabled="readonly" type="primary" @click="linkOperationRequirement">{{ getItemTitle('Operation Requirement') }}</el-button>
          <el-dropdown
            style="padding-left: 5px;"
            :disabled="readonly"
            split-button
            type="primary"
            no="1"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ getItemTitle(command1) }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Copy Last Time">{{ getItemTitle('Copy Last Time') }}</el-dropdown-item>
              <el-dropdown-item command="Copy By File NO">{{ getItemTitle('Copy By File NO') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!--分单信息/港口信息/关联方信息/装箱信息-->
    <div style="width: fit-content">
      <div style="display: flex" class="address-format-from">
        <div class="section form-column" style="width: 50%;">
          <!--分单信息-->
          <span class="title">{{ getItemTitle('HblInfo') }}</span>
          <el-form :disabled="readonly" label-width="110px" label-position="left" style="margin-left:18px;margin-right: 18px">
            <el-form-item label-width="0" class="auto-width">
              <cargo-ag-grid
                config-module="1001010"
                :grid-options="ams2.gridOptions"
                :column-defs="ams2ColumnDefs"
                :row-data="ams2.rowData"
                style="width:100%;height:200px"
                @gridReady="params=>{ams2.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button type="primary" :title="$t('SeaExport.addHbl')" no="5" @click="pm.btnAddHblHandler()">{{ getItemTitle('Add HB/L') }}</el-button>
                  <el-button type="primary" :title="$t('SeaExport.SynchronizeHBLInformation')" no="2" @click="pm.btnSynchroClickHandlerByNewEns()">{{ getItemTitle('Import HB/L') }}</el-button>
                  <el-button type="danger" :title="$t('SeaExport.Delete')" no="4" @click="pm.onRemoveCargoDocAi()">{{ getItemTitle('Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <!--港口信息-->
          <span class="title" style="margin-top: 46px" :title="$t('SeaExport.PortInformation')">{{ getItemTitle('Port Information') }}</span>
          <el-form :disabled="readonly" label-width="110px" label-position="top" style="margin-left:18px;margin-right: 18px">
            <!-- 港口信息-起运港 -->
            <el-row :gutter="20"> <!-- 设置列之间的间距为20px -->
              <el-col :span="12">
                <el-form-item :label="getItemTitle('Place of Loading')" class="blue-text">
                  <cargo-advance-select
                    no="loadingPortCode"
                    filterable
                    :static-options="protList"
                    :cache="false"
                    tag-value="code"
                    :filter-tag-names="['code','englishName']"
                    :default-value="form.loadingPortCode"
                    tag-name="englishName"
                    :show-custom-label-in-option="true"
                    :custom-label="(item) => customLabelHandler('Place of Loading', item)"
                    @parentCallBack="p=>{form.loadingPortCode = p.value}"
                  />
                </el-form-item>
              </el-col>
              <!-- 港口信息-目的港 -->
              <el-col :span="12">
                <el-form-item v-show="form.frob === 'I'" :label="getItemTitle('Place of Discharge')" class="blue-text">
                  <cargo-advance-select
                    :static-options="protList"
                    :cache="false"
                    tag-value="code"
                    filterable
                    :filter-tag-names="['code','englishName']"
                    :default-value="form.dischargingPortCode||''"
                    tag-name="englishName"
                    no="dischargingPortCode"
                    :show-custom-label-in-option="true"
                    :custom-label="(item) => customLabelHandler('Place of Discharge', item)"
                    @parentCallBack="p=>{form.dischargingPortCode = p.value}"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 港口信息-抵美前最后港口 -->
            <el-row :gutter="20"> <!-- 设置列之间的间距为20px -->
              <el-col :span="12">
                <el-form-item :label="getItemTitle('Last Foreign Port')" class="blue-text">
                  <cargo-advance-select
                    filterable
                    :filter-tag-names="['code','englishName']"
                    :static-options="noUsProtList"
                    tag-value="code"
                    :cache="false"
                    :default-value="form.lastAbroadProd"
                    no="27"
                    :show-custom-label-in-option="true"
                    :custom-label="(item) => customLabelHandler('Last Foreign Port', item)"
                    @parentCallBack="p=>{form.lastAbroadProd = p.value}"
                  />
                </el-form-item>
              </el-col>
              <!-- 港口信息-抵美第一港口 -->
              <el-col :span="12">
                <el-form-item v-show="form.frob === 'F'" :label="getItemTitle('First Port of Call')" class="blue-text">
                  <cargo-advance-select
                    filterable
                    :filter-tag-names="['code','englishName']"
                    :static-options="usProtList"
                    :cache="false"
                    tag-value="code"
                    :default-value="form.firstPortOfCallCode"
                    no="27"
                    :show-custom-label-in-option="true"
                    :custom-label="(item) => customLabelHandler('First Port of Call', item)"
                    @parentCallBack="p=>{form.firstPortOfCallCode = p.value}"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <!--申报信息-->
          <span class="title" style="margin-top: 46px">{{ $t('SeaExport.DeclarationInformation') }}</span>
          <el-form :disabled="readonly" label-width="110px" label-position="left" style="margin-left:18px;margin-right: 18px">
            <!-- AMS申报信息-船公司 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="getItemTitle('Carrier')" class="blue-text">
                  <cargo-advance-select
                    no="amsScacCode"
                    :static-options="shipCompanyInfos"
                    :cache="false"
                    filterable
                    :filter-tag-names="['amsScacCode', 'shipCompanyCode', 'shipCompanyEnglishName', 'shipCompanyChineseName']"
                    tag-value="amsScacCode"
                    :default-value="form.carrierEori"
                    :show-custom-label-in-option="true"
                    :custom-label="(item) => customLabelHandler('Carrier', item)"
                    @parentCallBack="carrierEoriChange"
                  />
                </el-form-item>
              </el-col>
              <!-- AMS申报信息-无船承运人 SCAC -->
              <el-col :span="12">
                <el-form-item :label="getItemTitle('SCAC CODE')" class="blue-text">
                  <el-select v-model="form.nvoccScac" filterable :allow-create="true" no="37">
                    <el-option
                      v-for="item in localData.nvoccScacList"
                      :key="item"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- AMS申报信息-整拼类型 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="getItemTitle('Shippment Type')" class="blue-text">
                  <el-select
                    v-model="form.containerLoadType"
                    :placeholder="showPlaceholder('SeaExport.PleaseChoose')"
                    no="6"
                  >
                    <el-option
                      v-for="(item,index) in consignmentTypes"
                      :key="index"
                      :label="item"
                      :value="item"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- AMS申报信息-运输类型 -->
              <el-col :span="12">
                <el-form-item :label="getItemTitle('Shippment Type')" class="blue-text">
                  <el-select v-model="form.frob" no="frob">
                    <el-option :label="isChineseLanguage ? 'Import  |  直达美国' : 'F14  |  Import'" value="I" />
                    <el-option :label="isChineseLanguage ? 'FROB  |  货物途径美国' : 'Foreign cargo remaining on-board'" value="F" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- AMS申报信息-申报人 -->
            <el-row :gutter="20">
              <!-- AMS申报信息-主单号 -->
              <el-col :span="12">
                <el-form-item>
                  <span slot="label" class="blue-text">{{ getItemTitle('MB/L NO') }}</span>
                  <el-input v-model="form.mbl" :placeholder="showPlaceholder('SeaExport.PleaseEnterMbl')" :disabled="readonly" no="mbl" />
                </el-form-item>
              </el-col>
              <!-- AMS申报信息-船籍 -->
              <el-col :span="12">
                <el-form-item :label="getItemTitle('VesselFlag')" class="blue-text">
                  <cargo-advance-select
                    no="53"
                    :select-type="TYPE_NAMES.basic_data_Country"
                    :cache="false"
                    filterable
                    :default-value="form.nationalityCodeofVessel"
                    :filter-tag-names="['code','chineseName','name']"
                    tag-name="code"
                    tag-value="code"
                    :show-custom-label-in-option="true"
                    :custom-label="(item) => customLabelHandler('Country', item)"
                    @parentCallBack="p=>{form.nationalityCodeofVessel = p.value}"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="section form-column" style="width: 50%;">
          <!--收发通信息-->
          <span class="title">{{ getItemTitle('Sending and receiving messages') }}</span>
          <el-form class="form-address" :disabled="readonly" label-width="110px" label-position="left" style="margin-left:18px;margin-right: 18px">
            <!--收发通信息-发货人-->
            <el-form-item>
              <span slot="label">{{ getItemTitle('Shipper') }}</span>
              <cargo-company-select
                no="shipperCode"
                :method-params="{shipper:true,active:true}"
                :default-value="addressForm.shipperCode||''"
                style="display: inline-block;width:200px;margin-right: 5px"
                :allow-create="true"
                @change="val => {shipperChange(val)}"
              />&nbsp;
              <el-button no="shipperBtnAiRecognition" type="primary" style="vertical-align: top;margin-left: 27px" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerByShipper, SystemConstants.AMS_AMS_PROMPT_KEY_ADDRESS.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
              <el-button no="shipperBtnCodeSearching" type="primary" style="vertical-align: top;margin-left: 27px !important" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue-text">{{ getItemTitle('name') }}</span>
              <el-input v-model="addressForm.shipperLine1" :placeholder="showPlaceholder('SeaExport.PleaseEnterHeader')" :filter-chars="false" no="shipperLine1" @dblclick.native="showSenderAndReceiverDialog('shipper', 3)" @input="validateAddressField('shipperLine1')" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue-text">{{ getItemTitle('Address1') }}</span>
              <el-input v-model="addressForm.shipperLine3" :placeholder="showPlaceholder('SeaExport.PleaseEnterAddress')" :filter-chars="false" no="shipperLine3" @dblclick.native="showSenderAndReceiverDialog('shipper', 3)" @input="validateAddressField('shipperLine3')" />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ getItemTitle('Address2') }}</span>
              <el-input v-model="addressForm.shipperLine4" :placeholder="showPlaceholder('SeaExport.PleaseEnterAddress2')" :filter-chars="false" no="shipperLine4" @dblclick.native="showSenderAndReceiverDialog('shipper', 3)" @input="validateAddressField('shipperLine4')" />
            </el-form-item>
            <el-form-item>
              <span slot="label" :title="$t('SeaExport.Country')">{{ getItemTitle('Country') }}</span>
              <div style="display: flex; justify-content: space-between;">
                <div style="display: flex; align-items: center; width: 40%;">
                  <el-select
                    v-model="addressForm.shipperCountry"
                    filterable
                    :filter-tag-names="['code','chineseName','name']"
                    clearable
                    :placeholder="showPlaceholder('SeaExport.PleaseSelectCountry')"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in countryList"
                      :key="item.code"
                      :label="customLabelHandler('Country', item)"
                      :value="item.code"
                    />
                  </el-select>
                </div>
                <div style="display: flex; align-items: center; width: 60%;">
                  <span class="center-label" :title="$t('SeaExport.Province')" style="text-align: right;">{{ getItemTitle('State') }}</span>
                  <el-input v-model="addressForm.shipperProvince" :placeholder="showPlaceholder('SeaExport.PleaseEnterState')" no="shipperProvince" />
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" :title="$t('SeaExport.City')">{{ getItemTitle('City') }}</span>
              <div style="display: flex; justify-content: space-between;">
                <div style="display: flex; align-items: center; width: 40%;">
                  <el-input v-model="addressForm.shipperCity" :placeholder="showPlaceholder('SeaExport.PleaseEnterCity')" no="shipperCity" @input="validateCityField('shipperCity')" />
                </div>
                <div style="display: flex; align-items: center; width: 60%;">
                  <span class="center-label" :title="$t('SeaExport.ZIP')" style="text-align: right;">{{ getItemTitle('ZIP') }}</span>
                  <el-input v-model="addressForm.shipperPostalcode" :placeholder="showPlaceholder('SeaExport.PleaseEnterPostalCode')" no="shipperPostalcode" />
                </div>
              </div>
            </el-form-item>
            <!--收发通信息-收货人-->
            <el-form-item style="margin-top: 20px">
              <span slot="label">{{ getItemTitle('Consignee') }}</span>
              <cargo-company-select
                no="consigneeCode"
                :method-params="{shipper:true,active:true}"
                :default-value="addressForm.consigneeCode||''"
                style="display: inline-block;width:200px;margin-right: 5px"
                :allow-create="true"
                @change="val => {consigneeChange(val)}"
              />&nbsp;
              <el-button no="consigneeBtnAiRecognition" type="primary" style="vertical-align: top;margin-left: 27px" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerByConsignee, SystemConstants.AMS_AMS_PROMPT_KEY_ADDRESS.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
              <el-button no="consigneeBtnCodeSearching" type="primary" style="vertical-align: top;margin-left: 27px !important" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
            </el-form-item>
            <el-form-item :title="$t('SeaExport.CompanyTitle')">
              <span slot="label" class="blue-text">{{ getItemTitle('name') }}</span>
              <el-input v-model="addressForm.consigneeLine1" :placeholder="showPlaceholder('SeaExport.PleaseEnterHeader')" :filter-chars="false" no="consigneeLine1" @dblclick.native="showSenderAndReceiverDialog('consignee', 3)" @input="validateAddressField('consigneeLine1')" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue-text">{{ getItemTitle('Address1') }}</span>
              <el-input v-model="addressForm.consigneeLine3" :placeholder="showPlaceholder('SeaExport.PleaseEnterAddress')" :filter-chars="false" no="consigneeLine3" @dblclick.native="showSenderAndReceiverDialog('consignee', 3)" @input="validateAddressField('consigneeLine3')" />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.Addr') + '2'">
              <span slot="label">{{ getItemTitle('Address2') }}</span>
              <el-input v-model="addressForm.consigneeLine4" :placeholder="showPlaceholder('SeaExport.PleaseEnterAddress2')" :filter-chars="false" no="consigneeLine4" @dblclick.native="showSenderAndReceiverDialog('consignee', 3)" @input="validateAddressField('consigneeLine4')" />
            </el-form-item>
            <el-form-item>
              <span slot="label" :title="$t('SeaExport.Country')">{{ getItemTitle('Country') }}</span>
              <div style="display: flex; justify-content: space-between;">
                <div style="display: flex; align-items: center; width: 40%;">
                  <el-select
                    v-model="addressForm.consigneeCountry"
                    filterable
                    :filter-tag-names="['code','chineseName','name']"
                    clearable
                    :placeholder="showPlaceholder('SeaExport.PleaseSelectCountry')"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in countryList"
                      :key="item.code"
                      :label="customLabelHandler('Country', item)"
                      :value="item.code"
                    />
                  </el-select>
                </div>
                <div style="display: flex; align-items: center; width: 60%;">
                  <span class="center-label" :title="$t('SeaExport.Province')" style="text-align: right;">{{ getItemTitle('State') }}</span>
                  <el-input v-model="addressForm.consigneeProvince" :placeholder="showPlaceholder('SeaExport.PleaseEnterState')" no="consigneeProvince" />
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" :title="$t('SeaExport.City')">{{ getItemTitle('City') }}</span>
              <div style="display: flex; justify-content: space-between;">
                <div style="display: flex; align-items: center; width: 40%;">
                  <el-input v-model="addressForm.consigneeCity" :placeholder="showPlaceholder('SeaExport.PleaseEnterCity')" no="consigneeCity" @input="validateCityField('consigneeCity')" />
                </div>
                <div style="display: flex; align-items: center; width: 60%;">
                  <span class="center-label" :title="$t('SeaExport.ZIP')" style="text-align: right;">{{ getItemTitle('ZIP') }}</span>
                  <el-input v-model="addressForm.consigneePostalcode" :placeholder="showPlaceholder('SeaExport.PleaseEnterPostalCode')" no="consigneePostalcode" />
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--装箱信息-->
      <div class="section">
        <span class="title" :title="$t('SeaExport.ContainerInformation')">{{ getItemTitle('House Container Information') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button type="primary" :title="$t('SeaExport.AddContainerInformation')" no="71" @click="cargoDocUsageSelectedDialog.visible=true">{{ getItemTitle('Import Container No') }}</el-button>
            <el-button type="primary" :title="$t('SeaExport.AddContainerInformation')" no="89" @click="addContainerUsageClickHandler">{{ getItemTitle('Add Container No') }}</el-button>
            <el-button type="danger" :title="$t('SeaExport.RemoveContainerInformation')" no="72" @click="removeContainerUsageClickHandler">{{ getItemTitle('Delete') }}</el-button>
            <el-button type="primary" :title="$t('SeaExport.AiRecognition')" no="90" @click="aiRecognitionHandler(false, aiRecognitionPostHandlerByCargo, SystemConstants.AMS_AMS_PROMPT_KEY_CONTAINER.code)">{{ getItemTitle('Ai Recognition') }}</el-button>
          </div>
          <cargo-ag-grid
            config-module="131706"
            :grid-options="container.gridOptions"
            :column-defs="containerColumnDefs"
            :row-data="containerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{container.gridApi=params.api}"
          />
        </div>
      </div>
    </div>
    <!-- 选择装箱信息弹窗 -->
    <cargo-doc-usage-selected-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.AMS_NEW"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
    <!-- 单号抄录弹窗 -->
    <afr-address-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      :no-label="amsTitle"
      :no-title="amsTitleCn"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      @callback="codeSearchCallback"
    />
    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :job-uuid="aiRecognitionDialog.jobUuid"
      :doc-uuid="aiRecognitionDialog.docUuid"
      :hbl-nbr2="aiRecognitionDialog.hblNbr2"
      :source="aiRecognitionDialog.source"
      :prompt-key="aiRecognitionDialog.promptKey"
      page-source="amsInfo"
      :i-channel="aiRecognitionDialog.iChannel"
      :call-back="aiRecognitionDialog.callBack"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :warning-count="70"
        :disabled="readonly"
        style="height: 198px;"
        no="46"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" no="47" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="48"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!--校验弹框提示-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="checkDialog.visible"
      :title="checkDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        :grid-options="checkDialog.gridOptions"
        :column-defs="checkDialog.columnDefs"
        :row-data="checkDialog.rowData"
        :show-side-bar="false"
        style="height:350px"
        @gridReady="params=>{checkDialog.gridApi=params.api}"
      />
    </el-dialog>
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'
import BillAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoDocUsageSelectedDialog from '@/components/Cargo/Job/cargoDocUsageSelectedDialog'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { Company } from '@/class/model/mdm/Company'
import AfrAddressDialog from '@/components/Cargo/Job/afrAddressDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getCacheListByKey, getObjectByCacheMatchFiled, getSpecificBasicData } from '@/utils/basicDataCache'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { EDIContainer } from '@/class/model/booking/EDIContainer'
import { formatNumberToThousands } from '@/utils'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'

export default {
  name: 'AmsInfoAi',
  components: {
    CargoCompanySelect,
    AfrAddressDialog,
    cargoAdvanceSelect, cargoInput, cargoDocUsageSelectedDialog,
    BillAddressDialog,
    CargoAiRecognitionDialog,
    CargoRichTextarea
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    },
    ams2: { type: Object, default: () => {} },
    container: { type: Object, default: () => {} },
    form: { type: Object, default: () => {} },
    pm: { type: Object, default: () => {} },
    localData: { type: Object, default: () => {} },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      aiRecognitionDialog: {
        multimodal: false,
        jobUuid: '',
        docUuid: '',
        hblNbr2: '',
        source: 0,
        pageSource: '',
        iChannel: 0,
        callBack: null,
        visible: false,
        promptKey: ''
      },
      checkDialog: {
        visible: false,
        title: this.$t('SeaExport.VerificationPrompt'),
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.Field'),
            field: 'field',
            width: 250
          },
          {
            headerName: this.$t('SeaExport.ErrorDescription'),
            field: 'errorDescription',
            width: 325
          }
        ],
        rowData: [],
        gridApi: null
      },
      SystemConstants,
      URL,
      visible: false,
      moment,
      TYPE_NAMES,
      CargoDocConsts,
      CargoDocUtil,
      command1: 'Copy Last Time',
      cargoDocUsageSelectedDialog: {
        visible: false,
        callback: rows => {
          this.pm.usageSelectCallBackFunc(rows, true)
        }
      },
      billAddressDialog: {
        visible: false
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      isChineseLanguage: false,
      countryList: getCacheListByKey(TYPE_NAMES.basic_data_Country),
      consignmentTypes: ['FCL', 'LCL', 'BBK'],
      protList: [],
      usProtList: [],
      noUsProtList: [],
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          maxChar: 45
        }
      }
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    job() {
      return this.pm.job
    },
    amsTitle() {
      return this.pm.getNoTitle(false, this.tabName)
    },
    amsTitleCn() {
      return this.pm.getNoTitle(true, this.tabName)
    },
    shipCompanyInfos() {
      if (this.localData.shipCompanyInfos) {
        const filtered = this.localData.shipCompanyInfos.filter(c => c.amsScacCode)
        const uniqueMap = new Map()
        filtered.forEach(item => {
          if (!uniqueMap.has(item.amsScacCode)) {
            uniqueMap.set(item.amsScacCode, item)
          }
        })
        return Array.from(uniqueMap.values())
      }
      return []
    },
    containerColumnDefs() {
      return [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.getItemTitle('No'),
          field: '',
          colId: '',
          minWidth: 140,
          cellRenderer: function(params) {
            return params.rowIndex + 1
          }
        },
        {
          headerName: this.getItemTitle('Container No'),
          headerTooltip: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 160,
          editable: this.isEdit,
          onCellValueChanged: (params) => {
            if (params.newValue) {
              const validated = this.validateContainerNo(params.newValue)
              if (validated !== params.newValue) {
                params.node.setDataValue('containerNo', validated)
              }
            }
          }
        },
        {
          headerName: this.getItemTitle('Gross Weight'),
          headerTooltip: this.$t('SeaExport.GrossWeight'),
          colId: 'weight',
          field: 'weight',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                let precision = 3
                if (this.jsSendHide) {
                  precision = 0
                }
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, precision))
              }
            }
          }
        },
        {
          headerName: this.getItemTitle('Quantity'),
          headerTooltip: this.$t('SeaExport.itemCount'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, 0))
              }
            }
          }
        },
        {
          headerName: this.getItemTitle('Unit Type'),
          headerTooltip: this.$t('SeaExport.Packing'),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          colId: 'packing',
          field: 'packing',
          width: 160,
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Packing,
              filterable: true,
              tagValue: 'code',
              customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.englishName}[${item.name}]`,
              showCustomLabelInOption: true
            }
          },
          valueFormatter: params => {
            return ColumnUtils.packingCodeLabelFun(params.value)
          }
        },
        {
          headerName: this.getItemTitle('Volume'),
          headerTooltip: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 160,
          cellStyle: (params) => {
            return this.setCellColor(params.data, params.colDef.field)
          },
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            isEdit: this.isEdit,
            tag: 'cargo-cell-input',
            attrs: {
              complexTextConverter: (data, val) => {
                let precision = 3
                if (this.jsSendHide) {
                  precision = 0
                }
                return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(val, precision))
              }
            }
          }
        },
        {
          headerName: this.getItemTitle('Marks'),
          headerTooltip: this.$t('SeaExport.ShippingMark'),
          colId: 'mark',
          field: 'mark',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Marks')
          },
          onCellValueChanged: (params) => {
            if (params.newValue) {
              const validated = this.validateMarksDescription(params.newValue)
              if (validated !== params.newValue) {
                params.node.setDataValue('mark', validated)
              }
            }
          }
        },
        {
          headerName: this.getItemTitle('Description'),
          headerTooltip: this.$t('SeaExport.CommodityName'),
          colId: 'cargoName',
          field: 'cargoName',
          width: 120,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Goods')
          },
          onCellValueChanged: (params) => {
            if (params.newValue) {
              const validated = this.validateMarksDescription(params.newValue)
              if (validated !== params.newValue) {
                params.node.setDataValue('cargoName', validated)
              }
            }
          }
        },
        {
          headerName: this.getItemTitle('Hazardous code'),
          headerTooltip: this.$t('SeaExport.DangerousCode'),
          colId: 'undgNumber',
          field: 'undgNumber',
          width: 100,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceTextEditor',
          cellEditorParams: {
            fitContent: true,
            title: this.getItemTitle('Hazardous code')
          }
        }
      ]
    },
    containerFinalRowData() {
      return this.container.rowData.filter(p => !p.deleted)
    },
    ams2ColumnDefs() {
      return [
        {
          headerName: this.getItemTitle('AMS No'),
          colId: 'hblNbr2',
          field: 'hblNbr2',
          flex: 1,
          width: 260,
          editable: this.isEdit,
          onCellValueChanged: (params) => {
            if (params) {
              this.validateHblNo(params)
              this.onHblNbr2CellChange(params)
            }
          }
        },
        {
          headerName: this.getItemTitle('Transmit Status'),
          colId: 'AMSSTATUS',
          field: 'AMSSTATUS',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            if (params.value === 1) {
              return this.pm.setStatusWithColor(1, this.isChineseLanguage)
            } else {
              return this.pm.setStatusWithColor(null, this.isChineseLanguage)
            }
          }
        },
        {
          headerName: this.getItemTitle('Customs Status'),
          colId: 'amsReceiptStatus',
          field: 'amsReceiptStatus',
          flex: 1,
          width: 260,
          cellRenderer: params => {
            return this.pm.setCustomsStatusWithColor(params.value, this.isChineseLanguage)
          }
        }
      ]
    },
    language() {
      return this.$store.getters.language
    },
    addressForm() {
      return this.form.afrAddress[0] || {}
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.visible = true
    this.isChineseLanguage = this.$store.getters.language === 'zh'
    const port = await getSpecificBasicData(TYPE_NAMES.basic_data_Seaport)
    this.protList = port || []
    this.noUsProtList = port.filter(p => !p.code || !(p.code && p.code.substring(0, 2) === 'US')) || []
    this.usProtList = port.filter(p => !p.code || (p.code && p.code.substring(0, 2) === 'US')) || []
  },
  methods: {
    // ams no 字段验证方法
    validateHblNo(params) {
      // 转大写并过滤不合规字符
      const valueHblNbr2 = params.newValue
        .toUpperCase()
        .replace(/[^A-Z0-9\-/]/g, '')

      if (valueHblNbr2 !== params.newValue) {
        // 如果值被格式化，更新单元格的值
        params.node.setDataValue(params.column.colId, valueHblNbr2)
      }
    },
    // ams no 字段不可重复 不可为空
    onHblNbr2CellChange(params) {
      // 检查分单号是否为空
      if (!params.newValue || params.newValue.trim() === '') {
        this.$message.warning(this.$t('Message.HAWBCannotBeNull'))
        params.data.hblNbr2 = params.oldValue
        this.ams2.gridApi.refreshCells({ force: true })
        return
      }

      // 检查分单号是否重复
      const isDuplicate = this.ams2.rowData.some(doc =>
        doc !== params.data && doc.hblNbr2 === params.newValue
      )
      if (isDuplicate) {
        this.$message.warning(this.$t('Message.HAWBCannotBeRepeated'))
        params.data.hblNbr2 = params.oldValue
        this.ams2.gridApi.refreshCells({ force: true })
        return
      }

      // 更新对应的 cargoDoc
      const cargoDoc = this.pm.cargoDocs.find(doc => doc.hblNbr2 === params.oldValue)
      if (cargoDoc) {
        cargoDoc.hblNbr2 = params.newValue
        // 如果是当前编辑的表单，同步更新 form
        if (this.pm.form && this.pm.form.uuid === cargoDoc.uuid) {
          this.pm.form.hblNbr2 = params.newValue
        }
      }

      // 更新表格数据
      const rowIndex = this.ams2.rowData.findIndex(row => row.hblNbr2 === params.oldValue)
      if (rowIndex !== -1) {
        this.ams2.rowData[rowIndex].hblNbr2 = params.newValue
        // 强制更新数组以触发视图更新
        this.ams2.rowData = [...this.ams2.rowData]
      }

      // 刷新表格显示
      this.ams2.gridApi.refreshCells({
        force: true,
        columns: ['hblNbr2']
      })
    },
    // 地址信息 字段验证方法
    validateAddressField(value) {
      if (!this.addressForm[value]) return
      // 允许大小写字母、数字、短横杠、斜杠、逗号、空格、冒号、引号、加号、下划线
      const validChars = /[A-Za-z0-9\-/,\s:"'_+]/g
      this.addressForm[value] = this.addressForm[value].match(validChars)?.join('') || ''
    },
    // 城市 字段验证方法
    validateCityField(value) {
      if (!this.addressForm[value]) return
      // 只允许大写字母、数字、空格、斜杠、短横杠
      this.addressForm[value] = this.addressForm[value].toUpperCase()
      this.addressForm[value] = this.addressForm[value].replace(/[^A-Z0-9\s/\-]/g, '')
    },
    // 箱号校验
    validateContainerNo(value) {
      if (!value) return value
      // 11个字符
      let processed = value.toUpperCase().substring(0, 11)
      // 移除不合规字符
      processed = processed.replace(/[^A-Z0-9]/g, '')
      return processed
    },
    // 唛头 备注校验
    validateMarksDescription(value) {
      if (!value) return value
      // 与地址字段相同的验证规则
      const validChars = /[A-Za-z0-9\-/,\s:"'_+]/g
      return value.match(validChars)?.join('') || ''
    },

    addContainerUsageClickHandler() {
      const baseContainer = new EDIContainer().fillDefaultValue().getData()
      baseContainer.deleted = false
      baseContainer.containerNo = ''
      baseContainer.sealNo = ''
      baseContainer.eqType = ''
      baseContainer.eqSize = ''
      baseContainer.cargoDocUuid = this.form.uuid
      baseContainer.containerUsageUuid = null
      this.container.rowData.push(baseContainer)
    },
    removeContainerUsageClickHandler() {
      const rows = this.container.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        if (row.uuid) {
          row.deleted = true
        } else {
          const index = this.container.rowData.findIndex(p => p === row)
          if (index >= 0) {
            this.container.rowData.splice(index, 1)
          }
        }
      }
      const tempRowData = this.container.rowData
      this.container.rowData = []
      this.$nextTick(() => {
        this.container.rowData = tempRowData
        if (this.form.docType === CargoDocConsts.AMS) {
          this.pm.refreshEdiGrid()
        }
      })
    },
    commandHandle(command) {
      switch (command) {
        case 'Code Searching':
          this.billAddressDialog.visible = true
          break
        case 'Copy Last Time':
          this.pm.onCopy1()
          break
        case 'Copy By File NO':
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'AMS',
            selectType: 'single',
            job: this.job
          })
          this.searchBillNoDialog.visible = true
          break
      }
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.amsAiLabelFunc(targetCode)
      }
      return targetCode
    },
    aiRecognitionHandler(multimodal = true, callBack = null, promptKey = '') {
      this.aiRecognitionDialog.multimodal = multimodal
      this.aiRecognitionDialog.jobUuid = this.job.uuid
      this.aiRecognitionDialog.docUuid = this.form.uuid
      this.aiRecognitionDialog.hblNbr2 = this.form.hblNbr2
      this.aiRecognitionDialog.source = multimodal ? SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_15.code : 0
      this.aiRecognitionDialog.pageSource = 'amsInfo'
      this.aiRecognitionDialog.iChannel = SystemConstants.SENDING_6.code
      this.aiRecognitionDialog.callBack = callBack
      this.aiRecognitionDialog.promptKey = promptKey
      this.aiRecognitionDialog.visible = true
    },
    showPlaceholder(text) {
      if (this.readonly) {
        return ''
      } else {
        return this.$t(text)
      }
    },
    linkOperationRequirement() {
      window.open('https://n72qv2rrvp.feishu.cn/wiki/HvR9wODtVinSiCkcjgechZm3nVK', '_blank')
    },
    customLabelHandler(field, item) {
      switch (field) {
        case 'Carrier':
          return !item ? '' : this.isChineseLanguage ? `${this.isValue(item.shipCompanyCode)} | ${item.amsScacCode} | ${this.isValue(item.shipCompanyEnglishName)} | ${this.isValue(item.shipCompanyChineseName)}` : `${this.isValue(item.shipCompanyCode)} | ${item.amsScacCode} | ${this.isValue(item.shipCompanyEnglishName)}`
        case 'Declarant':
          return !item ? '' : this.isChineseLanguage ? `${item.eori} | ${item.name}` : `${item.eori} | ${item.name}`
        case 'Place of Loading':
        case 'Place of Discharge':
        case 'Last Foreign Port':
        case 'First Port of Call':
          return !item ? '' : `${item.code} | ${item.englishName}`
        case 'Country':
          return !item ? '' : this.isChineseLanguage ? `${item.code} | ${item.name} | ${item.chineseName} ` : `${item.code} | ${item.name}`
      }
    },
    isValue(data) {
      if (data) {
        return data
      }
      return '-'
    },
    carrierEoriChange(data) {
      this.form.carrierEori = data.amsScacCode
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.addressForm['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.addressForm['consigneeCode'] = data.consigneeCode || ''
      }
    },
    splitShipperLine(data) {
      this.splitSenderAndReceiverLine('shipper', 5, data.shipperInfo)
      this.splitAddress('shipper', data)
    },
    splitConsigneeLine(data) {
      this.splitSenderAndReceiverLine('consignee', 5, data.consigneeInfo)
      this.splitAddress('consignee', data)
    },
    splitSenderAndReceiverLine(type, count, val) {
      const addressForm = this.addressForm
      let fromIndex = 0
      let i = 1
      let no = 1
      for (; i < count; ++i) {
        no = (i !== 1) ? (i + 1) : i
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          addressForm[`${type}Line${no}`] = ''
          continue
        }
        addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      addressForm[`${type}Line${no}`] = val.substring(fromIndex)
    },
    splitAddress(type, data) {
      const addressForm = this.addressForm
      addressForm[type + 'Country'] = data[type + 'CountryCode'] || ''
      addressForm[type + 'City'] = data[type + 'CityName'] || ''
      addressForm[type + 'Postalcode'] = data[type + 'ZipCode'] || ''
      addressForm[type + 'Province'] = data[type + 'ProvinceCode'] || ''
    },
    aiRecognitionPostHandlerByShipper(jsonStr) {
      this.processAiRecognition(jsonStr, 'shipper')
    },
    aiRecognitionPostHandlerByConsignee(jsonStr) {
      this.processAiRecognition(jsonStr, 'consignee')
    },
    processAiRecognition(jsonStr, type) {
      const data = this.processAiRecognitionData(jsonStr)
      if (!data) {
        return
      }

      if (data?.name) {
        this.addressForm[type + 'Line1'] = data.name
      }
      if (data?.address) {
        this.addressForm[type + 'Line3'] = data.address
      }
      if (data?.city) {
        this.addressForm[type + 'City'] = data.city
      }
      if (data?.province) {
        this.addressForm[type + 'Province'] = data.province
      }
      if (data?.postalcode) {
        this.addressForm[type + 'Postalcode'] = data.postalcode
      }
      if (data?.city) {
        this.addressForm[type + 'City'] = data.city
      }
      if (data?.streetNo) {
        this.addressForm[type + 'StreetNo'] = data.streetNo
        if (type === 'shipper') {
          this.form.noHouseNumberByShipper = this.addressForm.shipperStreetNo === 'N/A'
        } else if (type === 'consignee') {
          this.form.noHouseNumberByConsignee = this.addressForm.consigneeStreetNo === 'N/A'
        }
      }
      if (data?.country) {
        const country = getObjectByCacheMatchFiled(basicCacheKeys.basic_data_Country, ['code', 'name', 'chineseName'], data.country)
        if (country) {
          this.addressForm[type + 'Country'] = country.code
        }
      }
    },
    // AI识别后处理箱子和货物信息
    aiRecognitionPostHandlerByCargo(jsonStr) {
      try {
        // 解析JSON字符串
        const result = JSON.parse(jsonStr)

        // 验证数据格式
        if (!Array.isArray(result) || result.length === 0 || !result[0].text || !result[0].text.data) {
          return
        }

        const cargoInfoResult = result[0].text.data.cargoInfo

        // 验证货物信息是否有效
        if (!Array.isArray(cargoInfoResult) || cargoInfoResult.length === 0) {
          return
        }
        // 清洗数据 过滤筛选项匹配不到的内容
        // 拆分数据 将数据拆为箱子和货物
        const containerList = []
        this.pm.convertValidCagoInfoHandlerAms(cargoInfoResult, containerList)

        // 箱子处理更新的数据
        this.pm.aiRecognitionPostUpdateHandler(this.container.rowData, containerList, 'containerNo')

        // 更新箱子和货物的列表
        if (this.container) {
          this.container.gridOptions.api.clearFocusedCell()
          this.container.gridOptions.api.refreshCells({ force: true })
        }
      } catch (error) {
        console.log('error ===>', error)
      }
    },
    setCellColor(data, field) {
      const importDifferentField = this.localData.importDifferentField
      if (!importDifferentField ||
        !importDifferentField.container ||
        !importDifferentField.container[data.containerNo]) {
        return {}
      }
      if (importDifferentField.container[data.containerNo].hasOwnProperty(field)) {
        return { 'color': 'red' }
      }
      return {}
    },
    processAiRecognitionData(data) {
      const parsedData = typeof data === 'string' ? JSON.parse(data) : data
      if (!Array.isArray(parsedData) || !parsedData[0]?.text?.data) {
        return
      }
      return parsedData[0].text.data
    },
    showSenderAndReceiverDialog(type, count) {
      const value = this.mergeSenderAndReceiverLineForAmsAndManifest(type, count)
      switch (type) {
        case 'shipper':
          this.advanceTextDialog.title = this.$t('SeaExport.Shipper')
          break
        case 'consignee':
          this.advanceTextDialog.title = this.$t('SeaExport.Consignee')
          break
      }
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = () => this.splitSenderAndReceiverLineForAmsAndManifest(type, count, this.advanceTextDialog.value)
      this.advanceTextDialog.visible = true
    },
    mergeSenderAndReceiverLineForAmsAndManifest(type, count) {
      const addressForm = this.form.afrAddress[0]
      if (type === 'shipper' || type === 'consignee') {
        let result = ''
        for (let i = 1; i < count; ++i) {
          let no = i
          if (i !== 1) {
            no = (i + 1)
          }
          result += addressForm[`${type}Line${no}`] || ''
          result += '\n'
        }
        result += (addressForm[`${type}Line${count + 1}`] || '')
        return result.trimEnd()
      } else if (type === 'seller' || type === 'buyer') {
        const result2 = addressForm[`${type}Name`] + '\n' + addressForm[`${type}Address1`] + '\n' + addressForm[`${type}Address2`]
        return result2.trimEnd()
      } else {
        return addressForm[type].trimEnd()
      }
    },
    splitSenderAndReceiverLineForAmsAndManifest(type, count, val) {
      const addressForm = this.form.afrAddress[0]
      if (type === 'shipper' || type === 'consignee') {
        let fromIndex = 0
        let i = 1
        let no = 1
        for (; i < count; ++i) {
          no = (i !== 1) ? (i + 1) : i
          const index = val.indexOf('\n', fromIndex)
          if (index === -1) {
            addressForm[`${type}Line${no}`] = ''
            continue
          }
          addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
          fromIndex = index + 1
        }
        addressForm[`${type}Line${no + 1}`] = val.substring(fromIndex)
      } else {
        addressForm[type] = val
      }
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    openCheckTip(data) {
      this.checkDialog.visible = true
      // 去重
      const uniqueMap = new Map()
      if (data) {
        data.forEach(item => {
          let key = item.field + '|' + item.errorDescription
          if (item.type) {
            key = item.type + item.field + '|' + item.errorDescription
          }
          if (!uniqueMap.has(key)) {
            if (item.type) {
              item.field = this.getItemTitle(item.type) + ' ' + this.getItemTitle(item.field)
            } else {
              item.field = this.getItemTitle(item.field)
            }
            uniqueMap.set(key, item)
          }
        })
      }
      this.checkDialog.rowData = Array.from(uniqueMap.values())
    },
    /**
     * 发货人选择
     */
    async shipperChange(data) {
      const form = this.addressForm
      form.shipperId = data.value
      if (form.shipperId) {
        // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.shipperLine1 = manifestAddress.addressLine1
          // form.shipperLine2 = manifestAddress.addressLine2
          form.shipperLine3 = manifestAddress.addressLine2
          form.shipperLine4 = manifestAddress.addressLine3
          //
          let shipperLine5 = manifestAddress.addressLine4 || ''
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine5) shipperLine5 += manifestAddress.addressLine5
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine6) shipperLine5 += manifestAddress.addressLine6
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine7) shipperLine5 += manifestAddress.addressLine7
          form.shipperLine5 = shipperLine5
        } else {
          form.shipperLine1 = ''
          form.shipperLine2 = ''
          form.shipperLine3 = ''
          form.shipperLine4 = ''
          form.shipperLine5 = ''
          form.shipperLine6 = ''
          form.shipperLine7 = ''
        }
      }
    },
    /**
     * 收货人选择
     */
    async consigneeChange(data) {
      const form = this.addressForm
      form.consigneeId = data.value
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (form.consigneeId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.consigneeLine1 = manifestAddress.addressLine1
          // form.consigneeLine2 = manifestAddress.addressLine2
          form.consigneeLine3 = manifestAddress.addressLine2
          form.consigneeLine4 = manifestAddress.addressLine3
          //
          let consigneeLine5 = manifestAddress.addressLine4 || ''
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine5) consigneeLine5 += manifestAddress.addressLine5
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine6) consigneeLine5 += manifestAddress.addressLine6
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine7) consigneeLine5 += manifestAddress.addressLine7
          form.consigneeLine5 = consigneeLine5
        } else {
          form.consigneeLine1 = ''
          form.consigneeLine2 = ''
          form.consigneeLine3 = ''
          form.consigneeLine4 = ''
          form.consigneeLine5 = ''
          form.consigneeLine6 = ''
          form.consigneeLine7 = ''
        }
      }
    }
  }
}
</script>

<style lang="scss">
.ams-info{
  .warning .el-input__inner{
    color: red !important;
  }
  .warning{
    color: red !important;
  }
  .el-radio__label{
    font-size: 12px;
    font-weight: normal;
    color: #333333 !important;
  }
  .el-checkbox__label{
    font-weight: normal;
    color: #333333 !important;
  }
}
.blue-text{
  color: #1f75d5 !important;
}
.address-format-from{
  .center-label{
    margin-left: 5px;
    margin-right: 5px;
    width: 110px;
  }
}
.form-address .el-form-item {
  margin-bottom: 10px !important;
}
</style>
